<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Laporan Penjualan per Provinsi</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<!-- <v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn> -->
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<template v-if="this.isLoading">
			<v-progress-linear color="deep-purple accent-4" indeterminate rounded height="20">
				<template v-slot:default="{ value }">
					<div class="white--text">Harap menunggu . . .</div>
				</template>
			</v-progress-linear>
		</template>
		<template v-else>
			<v-card v-if="salesOrderReport.length > 0 || salesRetailReport.length > 0" outlined>
				<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
					<template v-slot:default>
						<thead>
							<tr>
								<td class="px-4 text-left" :colspan="headers.length">
									<div class="font-size-12 font-weigth-bold width-100">Sales Order</div>
								</td>
							</tr>
							<tr style="background-color: rgba(0, 0, 0, 0.1);">
								<template v-for="(header, index) in headers">
									<th width="150px" class="px-4" :key="index">{{ header.text }}</th>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(so, index) in salesOrderReport" :key="index">
								<td class="px-4 text-left">
									<div class="font-size-10">{{ so.title }}</div>
								</td>
								<template v-for="product in so.product">
									<td class="px-4 text-center" :key="product.product_code">
										<div class="font-size-10">{{ product.sales }}</div>
									</td>
								</template>
								<td class="px-4 text-center">
									<div class="font-size-10">{{ so.total_product }}</div>
								</td>
								<td class="px-4 text-center">
									<div class="font-size-10">{{ so.total_product_price_format }}</div>
								</td>
							</tr>
							<tr>
								<td class="px-4 text-left">
									<div class="font-size-10 font-weight-bold">Total</div>
								</td>
								<template v-for="product in salesOrderFooter.product">
									<td class="px-4 text-center" :key="product.product_code">
										<div class="font-size-10 font-weight-bold">{{ product.total }}</div>
									</td>
								</template>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ salesOrderFooter.total_product }}</div>
								</td>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ salesOrderFooter.total_product_price_format }}</div>
								</td>
							</tr>
						</tbody>
						<thead>
							<tr>
								<td class="px-4 text-left" :colspan="headers.length">
									<div class="font-size-12 font-weigth-bold width-100">Penjualan Langsung</div>
								</td>
							</tr>
							<tr style="background-color: rgba(0, 0, 0, 0.1);">
								<template v-for="(header, index) in headers">
									<th width="150px" class="px-4" :key="index">{{ header.text }}</th>
								</template>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(so, index) in salesRetailReport" :key="index">
								<td class="px-4 text-left">
									<div class="font-size-10">{{ so.title }}</div>
								</td>
								<template v-for="product in so.product">
									<td class="px-4 text-center" :key="product.product_code">
										<div class="font-size-10">{{ product.sales }}</div>
									</td>
								</template>
								<td class="px-4 text-center">
									<div class="font-size-10">{{ so.total_product }}</div>
								</td>
								<td class="px-4 text-center">
									<div class="font-size-10">{{ so.total_product_price_format }}</div>
								</td>
							</tr>
							<tr>
								<td class="px-4 text-left">
									<div class="font-size-10 font-weight-bold">Total</div>
								</td>
								<template v-for="product in salesRetailFooter.product">
									<td class="px-4 text-center" :key="product.product_code">
										<div class="font-size-10 font-weight-bold">{{ product.total }}</div>
									</td>
								</template>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ salesRetailFooter.total_product }}</div>
								</td>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ salesRetailFooter.total_product_price_format }}</div>
								</td>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<td :colspan="headers.length"></td>
							</tr>
							<tr>
								<td class="px-4 text-left">
									<div class="font-size-10 font-weight-bold">Grand Total</div>
								</td>
								<template v-for="product in grandTotal.product">
									<td class="px-4 text-center" :key="product.product_code">
										<div class="font-size-10 font-weight-bold">{{ product.total }}</div>
									</td>
								</template>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ grandTotal.total_product }}</div>
								</td>
								<td class="px-4 text-center">
									<div class="font-size-10 font-weight-bold">{{ grandTotal.total_product_price_format }}</div>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card>
			<v-card v-else class="py-4" outlined>
				<div>
					<not-found></not-found>
				</div>
			</v-card>
		</template>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import filterComponent from '@/components/Filter'

let this_year = new Date().getFullYear()
const list_year = []
for (let i = this_year; i >= 2016; i--) {
	list_year.push({
		value: i,
		text: i
	})
}

const list_month = [{
	value: '1',
	text: 'Januari'
}, {
	value: '2',
	text: 'Februari'
}, {
	value: '3',
	text: 'Maret'
}, {
	value: '4',
	text: 'April'
}, {
	value: '5',
	text: 'Mei'
}, {
	value: '6',
	text: 'Juni'
}, {
	value: '7',
	text: 'Juli'
}, {
	value: '8',
	text: 'Agustus'
}, {
	value: '9',
	text: 'September'
}, {
	value: '10',
	text: 'Oktober'
}, {
	value: '11',
	text: 'November'
}, {
	value: '12',
	text: 'Desember'
}]

const list_report_type = [{
	value: '1',
	text: 'Laporan per Bulan'
}, {
	value: '2',
	text: 'Laporan per Tahun'
}, {
	value: '3',
	text: 'Laporan Summary'
}]


export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	data() {
		return {
			sortBy: 'customer_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: ['5', '10', '20', '50', '100'],
			dropfilter: false,
			search: '',
			listYear: [],
			listSystem: [{
				value: 'not_selected',
				text: 'Belum Terpilih'
			}, {
				value: 'manual',
				text: 'Tanpa Sistem'
			}, {
				value: 'system',
				text: 'Melalui Sistem'
			}],
			listStatus: [{
				value: 'active',
				text: 'Aktif'
			}, {
				value: 'non_active',
				text: 'Tidak Aktif'
			}],
			params: [],
			filterData: [{
				type: 'selection-dynamic',
				label: 'Tipe Laporan',
				item: list_report_type,
				function: this.selectType,
				filter: {
					value: '1',
					comparison: '=',
					type: 'string',
					field: 'date_type',
					show: true
				}
			}, {
				type: 'selection-dynamic',
				label: 'Tahun',
				item: list_year,
				function: this.selectYear,
				filter: {
					value: new Date().getFullYear(),
					comparison: '=',
					type: 'string',
					field: 'year',
					show: true
				}
			}, {
				type: 'selection-dynamic',
				label: 'Bulan',
				item: list_month,
				function: this.selectMonth,
				filter: {
					value: `${new Date().getMonth() + 1}`,
					comparison: '=',
					type: 'string',
					field: 'month',
					show: true
				}
			}
			],
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('report', ['headers', 'grandTotal', 'salesOrderReport', 'salesOrderFooter', 'salesRetailReport', 'salesRetailFooter', 'isLoading']),
		filterType: function () {
			return this.filterData[0].filter.value
		},
		filterYear: function () {
			return this.filterData[1].filter.value
		},
	},
	methods: {
		...mapActions('report', ['getReportSummaryProvince', 'getOptionWarehouse', 'getOptionProvince', 'getOptionCity', 'getOptionSubdistrict']),
		...mapMutations(['setFilter', 'setSnackbar']),
		...mapMutations('report', ['resetState']),

		getData() {
			this.getReportSummaryProvince(this.queryString({ params: this.params }))
		},
		exportData() {
			this.exportCustomer(this.queryString({ params: this.params, sort: this.sortBy, dir: this.sortDir }))
		},
		searchFilter(data) {
			if(this.filterData[0].filter.value == 1) {
				if((this.filterData[1].filter.value == '' || this.filterData[1].filter.value == undefined) || (this.filterData[2].filter.value == '' || this.filterData[2].filter.value == undefined)) {
					this.setSnackbar({
						show: true,
						color: 'red darken-2',
						text: `Pilih tahun dan bulan laporan `
					})
				} else {
					this.params = data
					this.getData()
				}
			} else if(this.filterData[0].filter.value == 2) {
				if(this.filterData[1].filter.value == '' || this.filterData[1].filter.value == undefined) {
					this.setSnackbar({
						show: true,
						color: 'red darken-2',
						text: `Pilih tahun laporan `
					})
				} else {
					this.params = data
					this.getData()
				}
			} else if(this.filterData[0].filter.value == 3) {
				this.params = data
				this.getData()
			}
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		selectType(val) {
			if (typeof val == 'undefined') {
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: `Pilih tipe laporan `
				})
			}
		},
		selectYear(val) {
			if (typeof val == 'undefined') {
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: `Pilih tahun laporan `
				})
			}
		},
		selectMonth(val) {
			if (typeof val == 'undefined') {
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: `Pilih bulan laporan `
				})
			}
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Laporan Penjualan per Provinsi`)

		await this.setFilter(this.filterData)

		let arr_filter = [...this.filterParams].map((el) => {
			let filter_obj = Object.assign({}, el.filter)
			if (el.type == 'date' && filter_obj.value != []) {
				filter_obj.value = filter_obj.value.sort().join('::')
			}
			return filter_obj
		})

		let filtered = arr_filter.filter(el => el.value !== null && el.value !== undefined && el.value !== '')
		this.params = filtered

		await this.getData()
	},
	beforeDestroy() {
		// this.clearDataCustomer()
		this.resetState()
	},
	watch: {
		filterType: function (newVal) {
			if (newVal == 1) {
				this.filterData[1].filter.show = true
			}
			if (newVal == 2) {
				this.filterData[1].filter.show = true
				this.filterData[2].filter.show = false
				this.filterData[2].filter.value = ''
			}
			if (newVal == 3) {
				this.filterData[1].filter.show = false
				this.filterData[2].filter.show = false
				this.filterData[1].filter.value = ''
				this.filterData[2].filter.value = ''
			}
		},
		filterYear: function (newVal) {
			if (newVal !== '' && this.filterData[0].filter.value == 1) {
				this.filterData[2].filter.show = true
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>
